import React, {useCallback, useMemo} from 'react';
import { useDropzone } from 'react-dropzone';


const baseStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    transition: 'border .3s ease-in-out'
};

const activeStyle = {
    borderColor: '#0cd4c3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff4517'
};

function FileDropZone(props) {

    const onDrop = useCallback(acceptedFiles => {
        props.onUpdateFile(acceptedFiles, props.name)
    }, []);

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone({
        onDrop,
        accept: 'image/jpeg, image/png'
    });

    const style = useMemo(() => ({
        ...baseStyle,
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isDragActive,
        isDragReject,
        isDragAccept
    ]);

    return (
        <div {...getRootProps()}>
            <input {...getInputProps()} />
            <div
                style={{fontSize: "0.7rem", lineHeight: "0.9rem" , border: "2px dashed #e0e0e0", padding: "5px"}}
                dangerouslySetInnerHTML={{__html:(props.title)?props.title:'Cliquez ou déposez votre image ici' }}>

            </div>
        </div>
    )
};

export default FileDropZone;
